export const PermissionConst = {
    CUSTOMER: {
        CREATE: 'customer:create',
    },
    EXCHANGERATE: {
        LIST: 'exchangerate:rate:list'
    }
}